import React, { useState, useEffect, useContext } from 'react';
import Swal from "sweetalert2";
import axios from 'axios';

import { AppContext } from "../../../services/AppContext";
import AuthContext from '../../../context/auth-context';

import { MdEdit, MdErrorOutline, MdSave } from "react-icons/md";

import useInput from '../../../hooks/useInput';
import useGetPaises from '../../../hooks/useGetPaises';
import useGetContacto from '../../../hooks/useGetContacto';
import Card from '../../UI/Card';


const Contacto = props => {
    const { setAppValues } = useContext(AppContext);
    const authContext = useContext(AuthContext);

    const [block, setBlock] = useState(false);
    const [error, setError] = useState(false);

    const paises = useGetPaises();

    const contactoData = useGetContacto(authContext.token);
    
    useEffect(() => {

        if(contactoData.LOADING){
            Swal.fire({
                title: `Loading...
                    <div class="spinner-border text-primary mt-4" role="status" />
                `,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false
            });
            return;
        }
        Swal.close();

        if(contactoData.STATUS && contactoData.STATUS === "SUCCESS"){
            setError(false);

        } else if(contactoData.STATUS && contactoData.STATUS === "ERROR"){
            setError(true);

            Swal.fire({
                icon: 'error',
                title: "¡Error!",
                text: contactoData.ERROR.MESSAGE,
                showConfirmButton: false,
                showDenyButton: true,
                denyButtonText: "Aceptar",
                backdrop: true,
                allowOutsideClick: false
            });

        } else {
            setError(true);
            
            Swal.fire({
                icon: 'error',
                title: "¡Error!",
                text: 'Ocurrió un problema, intentelo más tarde',
                showConfirmButton: false,
            });
        }

    }, [contactoData]);

    
    // INPUT DIRECCION
    const direccionValidacion = value => value.trim() !== "";
    const {
        value: direccion,
        isValid: direccionIsValid,
        isTouched: direccionIsTouched,
        userChange: direccionUserChange,
        divInput: divDireccion,
        valueChangeHandler: direccionChangeHanlder,
        inputBlurHandler: direccionBlurHandler,
        scrollToDiv: scrollToDivDireccion,
        setInputValue: setDireccionValue
    } = useInput(direccionValidacion);

    useEffect(() => {
        if(!!contactoData.direccion && !direccionUserChange){
            setDireccionValue(contactoData.direccion);
        }
    }, [contactoData.direccion, direccionUserChange, setDireccionValue]);

    // INPUT PAIS
    const paisValidacion = value => value.trim() !== "";
    const {
        value: pais,
        isValid: paisIsValid,
        isTouched: paisIsTouched,
        userChange: paisUserChange,
        divInput: divPais,
        valueChangeHandler: paisChangeHanlder,
        inputBlurHandler: paisBlurHandler,
        scrollToDiv: scrollToDivPais,
        setInputValue: setPaisValue
    } = useInput(paisValidacion);

    useEffect(() => {
        if(!!contactoData.pais && !paisUserChange){
            setPaisValue(contactoData.pais);
        }
    }, [contactoData.pais, paisUserChange, setPaisValue]);

    //INPUT CIUDAD
    const ciudadValidacion = value => value.trim() !== "";
    const {
        value: ciudad,
        isValid: ciudadIsValid,
        isTouched: ciudadIsTouched,
        userChange: ciudadUserChange,
        divInput: divCiudad,
        valueChangeHandler: ciudadChangeHanlder,
        inputBlurHandler: ciudadBlurHandler,
        scrollToDiv: scrollToDivCiudad,
        setInputValue: setCiudadValue
    } = useInput(ciudadValidacion);

    useEffect(() => {
        if(!!contactoData.ciudad && !ciudadUserChange){
            setCiudadValue(contactoData.ciudad);
        }
    }, [contactoData.ciudad, ciudadUserChange, setCiudadValue]);

    /*Agregando input de prueba*/

     // INPUT PAIS
     /*
     const paisValidacion = value => value.trim() !== "";
     const {
         value: pais,
         isValid: paisIsValid,
         isTouched: paisIsTouched,
         userChange: paisUserChange,
         divInput: divPais,
         valueChangeHandler: paisChangeHanlder,
         inputBlurHandler: paisBlurHandler,
         scrollToDiv: scrollToDivPais,
         setInputValue: setPaisValue
     } = useInput(paisValidacion);
 
     useEffect(() => {
         if(!!contactoData.pais && !paisUserChange){
             setPaisValue(contactoData.pais);
         }
     }, [contactoData.pais, paisUserChange, setPaisValue]);
      */

 
    //INPUT TELEFONO PERSONAL
    const telefonoPersonalValidacion = value => (/^\d{8,14}$/ig).test(value);
    const {
        value: telefonoPersonal,
        isValid: telefonoPersonalIsValid,
        isTouched: telefonoPersonalIsTouched,
        userChange: telefonoPersonalUserChange,
        divInput: divTelefonoPersonal,
        valueChangeHandler: telefonoPersonalChangeHanlder,
        inputBlurHandler: telefonoPersonalBlurHandler,
        scrollToDiv: scrollToDivTelefonoPersonal,
        setInputValue: setTelefonoPersonalValue
    } = useInput(telefonoPersonalValidacion);

    useEffect(() => {
        if(!!contactoData.tel_personal && !telefonoPersonalUserChange){
            setTelefonoPersonalValue(contactoData.tel_personal);
        }
    }, [contactoData.tel_personal, telefonoPersonalUserChange, setTelefonoPersonalValue]);

    //INPUT TELEFONO MOVIL
    const telefonoMovilValidacion = value => (/^\d{8,14}$/ig).test(value);
    const {
        value: telefonoMovil,
        isValid: telefonoMovilIsValid,
        isTouched: telefonoMovilIsTouched,
        userChange: telefonoMovilUserChange,
        divInput: divTelefonoMovil,
        valueChangeHandler: telefonoMovilChangeHanlder,
        inputBlurHandler: telefonoMovilBlurHandler,
        scrollToDiv: scrollToDivTelefonoMovil,
        setInputValue: setTelefonoMovilValue
    } = useInput(telefonoMovilValidacion);

    useEffect(() => {
        if(!!contactoData.tel_movil && !telefonoMovilUserChange){
            setTelefonoMovilValue(contactoData.tel_movil);
        }
    }, [contactoData.tel_movil, telefonoMovilUserChange, setTelefonoMovilValue]);

    //INPUT NOMBRE CONTACTO DE EMERGENCIA
    const nombreEmergenciaValidacion = value => value.trim() !== "";
    const {
        value: nombreEmergencia,
        isValid: nombreEmergenciaIsValid,
        isTouched: nombreEmergenciaIsTouched,
        userChange: nombreEmergenciaUserChange,
        divInput: divNombreEmergencia,
        valueChangeHandler: nombreEmergenciaChangeHanlder,
        inputBlurHandler: nombreEmergenciaBlurHandler,
        scrollToDiv: scrollToDivNombreEmergencia,
        setInputValue: setNombreEmergenciaValue
    } = useInput(nombreEmergenciaValidacion);

    useEffect(() => {
        if(!!contactoData.contacto_emergencia && !nombreEmergenciaUserChange){
            setNombreEmergenciaValue(contactoData.contacto_emergencia);
        }
    }, [contactoData.contacto_emergencia, nombreEmergenciaUserChange, setNombreEmergenciaValue]);

    //INPUT TELEFONO DE EMERGENCIA
    const telefonoEmergenciaValidacion = value => (/^\d{8,14}$/ig).test(value);
    const {
        value: telefonoEmergencia,
        isValid: telefonoEmergenciaIsValid,
        isTouched: telefonoEmergenciaIsTouched,
        userChange: telefonoEmergenciaUserChange,
        divInput: divTelefonoEmergencia,
        valueChangeHandler: telefonoEmergenciaChangeHanlder,
        inputBlurHandler: telefonoEmergenciaBlurHandler,
        scrollToDiv: scrollToDivTelefonoEmergencia,
        setInputValue: setTelEmergenciaValue
    } = useInput(telefonoEmergenciaValidacion);

    useEffect(() => {
        if(!!contactoData.tel_emergencia && !telefonoEmergenciaUserChange){
            setTelEmergenciaValue(contactoData.tel_emergencia);
        }
    }, [contactoData.tel_emergencia, telefonoEmergenciaUserChange, setTelEmergenciaValue]);

    //INPUT CORREO ELECTRONICO
    const correoValidacion = value => (/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/).test(value);
    const {
        value: correo,
        isValid: correoIsValid,
        isTouched: correoIsTouched,
        userChange: correoUserChange,
        divInput: divCorreo,
        valueChangeHandler: correoChangeHanlder,
        inputBlurHandler: correoBlurHandler,
        scrollToDiv: scrollToDivCorreo,
        setInputValue: setCorreoValue
    } = useInput(correoValidacion);

    useEffect(() => {
        if(!!contactoData.email_personal && !correoUserChange){
            setCorreoValue(contactoData.email_personal);
        }
    }, [contactoData.email_personal, correoUserChange, setCorreoValue]);

    const handleEditar = () => {
        setBlock(!block);
    }

    const [isUpdate, setIsUpdate] = useState(false);
    
    useEffect(() => {
        let flag = !!contactoData.direccion && contactoData.direccion !== ""
        if(flag){
            setBlock(true);
            setIsUpdate(true);
        }
    }, [contactoData]);

    let formIsValid = false;

    if
    (
        direccionIsValid &&
        paisIsValid &&
        ciudadIsValid && 
        telefonoPersonalIsValid &&
        telefonoMovilIsValid &&
        nombreEmergenciaIsValid &&
        telefonoEmergenciaIsValid &&
        correoIsValid
    )
    {
        formIsValid = true;
    }

    const formSubmitHanlder = async(e) => {
        e.preventDefault();

        direccionBlurHandler();
        paisBlurHandler();
        ciudadBlurHandler();
        telefonoPersonalBlurHandler();
        telefonoMovilBlurHandler();
        nombreEmergenciaBlurHandler();
        telefonoEmergenciaBlurHandler();
        correoBlurHandler();
        
        if(!formIsValid){
            if(!direccionIsValid)
            {
                scrollToDivDireccion();
                return;   
            }
            
            if(!paisIsValid)
            {
                scrollToDivPais();
                return;   
            }
            if(!ciudadIsValid)
            {
                scrollToDivCiudad();
                return;   
            } 
            if(!telefonoPersonalIsValid)
            {
                scrollToDivTelefonoPersonal();
                return;   
            }
            if(!telefonoMovilIsValid)
            {
                scrollToDivTelefonoMovil();
                return;   
            }
            if(!nombreEmergenciaIsValid)
            {
                scrollToDivNombreEmergencia();
                return;   
            }
            if(!telefonoEmergenciaIsValid)
            {
                scrollToDivTelefonoEmergencia();
                return;   
            }
            if(!correoIsValid)
            {
                scrollToDivCorreo();
                return;   
            }
            
            return;
        }

        const form_data = new FormData();
        form_data.append('idToken', authContext.token);
        form_data.append('direccion', direccion);
        form_data.append('pais', pais);
        form_data.append('ciudad', ciudad);
        form_data.append('telPersonal', telefonoPersonal);
        form_data.append('movil',  telefonoMovil);
        form_data.append('nombreEmergencia', nombreEmergencia);
        form_data.append('telEmergencia', telefonoEmergencia);
        form_data.append('correo', correo);

        if(isUpdate)
        {
            form_data.append('updateContacto', 1);
        }else {
            form_data.append('saveContacto', 1);
        }

        axios.post(process.env.REACT_APP_API_URL, form_data)
            .then(res => {
                setAppValues(
                    prev => {
                        let perfil = prev.contacto ? prev.perfil : prev.perfil+25;
                        return { ...prev, contacto: true, perfil };
                    }
                );
                setBlock(true);
                setIsUpdate(true);
                props.onCompletado('contacto');
            })
            .catch((error) => {
                console.log(error)
                Swal.fire({
                    icon: 'error',
                    title: 'Ocurrió un problema, intentelo más tarde',
                    showConfirmButton: false,
                    timer: 3500
                });
            })
    }

    return (
        <>
        {
            error && 
            <div className="row">
                <div className="col-lg-12 mb-5">
                    <Card>
                        <div className="card-body d-flex align-items-center justify-content-center" style={{ height: '565px' }}>
                            <div className="text-center" style={{ color: 'rgba(0,0,0,.3)', fontSize: '2.5rem' }} >
                                <span style={{ fontSize: "7rem" }}><MdErrorOutline/></span>
                                <br />
                                ¡Error!
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        }
        { !error && 
            <div className="row">
                <div className="col-lg-12 mb-5">
                    <Card>
                        <div className="card-body">
                            <form className="row my-4" onSubmit={formSubmitHanlder}>

                                {/* DIRECCION */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divDireccion}>
                                    <label className="form-label text-black-50" htmlFor="direccion" style={{userSelected: "none"}}>Dirección</label>
                                    <input 
                                        type="text" 
                                        name="direccion" 
                                        className={`form-control form-control-sm shadow-sm ${direccionIsTouched ? ((direccionIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        value={direccion} 
                                        onChange={direccionChangeHanlder}
                                        onBlur={direccionBlurHandler}
                                        placeholder="Dirección" 
                                        autoComplete='off'
                                        readOnly={block ? true : false}
                                    />
                                    <div className="invalid-feedback" id="validacion-direccion">
                                        Campo obligatorio
                                    </div>
                                </div>

                                {/* PAIS */}
                                <div className="col-md-6 offset-md-1 mb-3" ref={divPais}>
                                    <label className="form-label text-black-50" htmlFor='pais' >País</label>
                                    <select 
                                        className={`form-select form-select-sm shadow-sm ${paisIsTouched ? ((paisIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        name='pais' 
                                        value={pais} 
                                        onChange={paisChangeHanlder}
                                        onBlur={paisBlurHandler}
                                        autoComplete='off'
                                        disabled={block ? true : false}
                                    >
                                        <option valeu="" defaultValue={'DEFAULT'} hidden={true}>Seleccionar país</option>
                                        {paises.map(pais => (
                                            <option key={pais.PAIS} value={pais.PAIS}>{pais.NOMBRE}</option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback" id="validacion-direccion">
                                        Campo obligatorio
                                    </div>
                                </div>


                                {/*
                                
                           
                                <div className="col-md-6 offset-md-1 mb-3" ref={divPais}>
                                    <label className="form-label text-black-50" htmlFor='pais' >País</label>
                                    <select 
                                        className={`form-select form-select-sm shadow-sm ${paisIsTouched ? ((paisIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        name='pais' 
                                        value={pais} 
                                        onChange={paisChangeHanlder}
                                        onBlur={paisBlurHandler}
                                        autoComplete='off'
                                        disabled={true}
                                    >
                                        <option valeu="" defaultValue={'DEFAULT'} hidden={true}>Código de area</option>
                                        {paises.map(pais => (
                                            <option key={pais.PAIS} value={pais.PAIS}>+{pais.CODIGO_AREA}</option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback" id="validacion-direccion">
                                        Campo obligatorio
                                    </div>
                                </div> 
                                
                                */

                                //Este es el true
                                /*<div className="col-md-6 offset-md-1 mb-3">
                                <select 
                                    className={`form-select form-select-sm shadow-sm`}
                                    value={pais} 
                                    autoComplete='off'
                                    disabled={true}
                                >
                                    <option value="" defaultValue={'DEFAULT'} hidden={true}>Código de área</option>
                                    {paises.map(pais => (
                                        <option key={pais.PAIS} value={pais.PAIS}>+{pais.CODIGO_AREA}</option>
                                    ))}
                                </select>
                            </div>*/ 

                                }

                              


                          

                                



                                {/* CIUDAD */}
                                <div className="col-md-6 offset-md-1 mb-3" ref={divCiudad}>
                                    <label className="form-label text-black-50" htmlFor='ciudad'>Ciudad</label>
                                    <input 
                                        type="text" 
                                        name="ciudad"
                                        className={`form-control form-control-sm shadow-sm ${ciudadIsTouched ? ((ciudadIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        value={ciudad}
                                        onChange={ciudadChangeHanlder}
                                        onBlur={ciudadBlurHandler}                                     
                                        placeholder="Ciudad o departamento"
                                        autoComplete='off'
                                        readOnly={block ? true : false}
                                    />
                                    <div className="invalid-feedback" id="validacion-direccion">
                                        Campo obligatorio
                                    </div>
                                </div>

                                <hr className="col-md-10 offset-md-1 my-4 text-black-50 shadow" />


                            {/*CODIGO DE AREA*/}

                                  
                                {/* TELEFONO PERSONAL */}

                        

                                <div className="col-md-8 offset-md-1 mb-3" ref={divTelefonoPersonal}>
                                    <label className="form-label text-black-50" htmlFor='telefonoPersonal'>Teléfono personal</label>

                                    <div className="input-group">

                                   
                                                        <select 
                                                            className={`form-select form-select-sm shadow-sm`}
                                                            value={pais} 
                                                            autoComplete='off'
                                                            disabled={true}
                                                         
                                                        >
                                                            <option value="" defaultValue={'DEFAULT'} hidden={true}>Código de área</option>
                                                            {paises.map(pais => (
                                                                <option key={pais.PAIS} value={pais.PAIS}>+{pais.CODIGO_AREA}</option>
                                                            ))}
                                                        </select>

                                                                {/*
                                                        <span className="input-group-btn" 
                                                         style={{
                                                            width: '10px'
                                                          }}
                                                        ></span> */ }


                                    <input 
                                        type="text" 
                                        name='telefonoPersonal' 
                                        className={`form-control form-control-sm shadow-sm ${telefonoPersonalIsTouched ? ((telefonoPersonalIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        value={telefonoPersonal}
                                        onChange={telefonoPersonalChangeHanlder}
                                        onBlur={telefonoPersonalBlurHandler}
                                        placeholder="Teléfono personal" 
                                        autoComplete='off'
                                        readOnly={block ? true : false}
                                        style={{
                                            width: '25%'
                                          }}
                                    />

                                    <div className="invalid-feedback" id="validacion-direccion">
                                        Campo obligatorio
                                    </div>
                                 </div> 
                                </div>



                                


                                
                                {/* TELEFONO MOVIL */}
                                <div className="col-md-8 offset-md-1 mb-3" ref={divTelefonoMovil}>
                                    <label className="form-label text-black-50" htmlFor='telefonoMovil' >Teléfono móvil</label>
                                    <div className="input-group">


                                    <select 
                                                            className={`form-select form-select-sm shadow-sm`}
                                                            value={pais} 
                                                            autoComplete='off'
                                                            disabled={true}
                                                         
                                                        >
                                                            <option value="" defaultValue={'DEFAULT'} hidden={true}>Código de área</option>
                                                            {paises.map(pais => (
                                                                <option key={pais.PAIS} value={pais.PAIS}>+{pais.CODIGO_AREA}</option>
                                                            ))}
                                                        </select>

                                    <input 
                                        type="text" 
                                        name='telefonoMovil' 
                                        className={`form-control form-control-sm shadow-sm ${telefonoMovilIsTouched ? ((telefonoMovilIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        value={telefonoMovil}
                                        onChange={telefonoMovilChangeHanlder}
                                        onBlur={telefonoMovilBlurHandler}
                                        placeholder="Teléfono móvil" 
                                        autoComplete='off'
                                        readOnly={block ? true : false}
                                        style={{
                                            width: '25%'
                                          }}
                                    />
                                    <div className="invalid-feedback" id="validacion-direccion">
                                        Campo obligatorio
                                    </div>
                                    </div> 

                                </div>

                                  {/* CORREO */}
                                  <div className="col-md-10 offset-md-1 mb-3" ref={divCorreo}>
                                    <label className="form-label text-black-50">Correo para contacto en este proceso</label>
                                    <input 
                                        type="email" 
                                        name='correo' 
                                        className={`form-control form-control-sm shadow-sm ${correoIsTouched ? ((correoIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        value={correo} 
                                        onChange={correoChangeHanlder}
                                        onBlur={correoBlurHandler}
                                        placeholder="ejemplo@ufm.edu" 
                                        autoComplete='off'
                                        readOnly={block ? true : false}
                                    />
                                    <div className="invalid-feedback" id="validacion-direccion">
                                        Campo obligatorio
                                    </div>
                                 

                                </div>
                                

                                {/* CONTACTO/TELEFONO DE EMERGENCIA */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divNombreEmergencia}>
                                    <label className="form-label text-black-50" ref={divTelefonoEmergencia}>Contacto de emergencia</label>
                                    <div className="input-group">
                                        <input 
                                            type="text" 
                                            name="nombreEmergencia"
                                            className={`form-control form-control-sm shadow-sm ${nombreEmergenciaIsTouched ? ((nombreEmergenciaIsValid) ? 'is-valid' : 'is-invalid') : ''}`}    
                                            value={nombreEmergencia}
                                            onChange={nombreEmergenciaChangeHanlder}
                                            onBlur={nombreEmergenciaBlurHandler}
                                            placeholder="Nombre"
                                            autoComplete='off'
                                            readOnly={block ? true : false}
                                        />
                                        <input 
                                            type="text" 
                                            name='telefonoEmergencia' 
                                            className={`form-control form-control-sm shadow-sm ${telefonoEmergenciaIsTouched ? ((telefonoEmergenciaIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                            value={telefonoEmergencia}
                                            onChange={telefonoEmergenciaChangeHanlder}
                                            onBlur={telefonoEmergenciaBlurHandler}
                                            placeholder="Teléfono" 
                                            autoComplete='off'
                                            readOnly={block ? true : false}
                                        />
                                        <div className="invalid-feedback" id="validacion-emergencia">
                                            Campos obligatorios
                                        </div>
                                    </div>
                                </div>

                              

                                <hr className="col-md-10 offset-md-1 my-4 text-black-50 shadow" />
                                
                                {/* EDITAR/GUARDAR */}
                                <div className="col-md-10 offset-md-1 mt-3" style={{textAlign: 'right'}}>
                                    <div className="btn-group">
                                        <button 
                                            className={`btn ${block ? 'btn-dark':'btn-outline-dark disabled'}`}
                                            type="button"
                                            onClick={() => handleEditar()}
                                            disabled={!block} >
                                            <MdEdit /> Editar
                                        </button>
                                        <button 
                                            className={`btn ${block ? 'btn-outline-danger disabled':'btn-danger'}`}
                                            type="submit"
                                            disabled={block} >
                                            <MdSave /> Guardar
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </Card>
                </div>
            </div>
        }
        </>
    );
}

export default Contacto;